'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.tutorial.list', [])
  .controller('TutorialListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tutorial/list/index.js